<div class="card campanha-pedido-nao-liberado-pipeline-card"
    [class.collapse-opened]="isCollapseOpened">
    <div class="card-header" (click)="toggleCollapse()">
        <p class="card-title">
            Pedidos Não Liberados

            <span class="badge badge-pill badge-secondary-light">
                <ng-template [ngIf]="isLoading">
                    <i class='fas fa-spinner fa-pulse'></i>
                </ng-template>
                <ng-template [ngIf]="!isLoading && isLoaded">
                    {{(pedidos?.length ? pedidos?.length : 0) | decimalFormat: 1:0:0}}
                </ng-template>                
            </span>       
        </p>

        <span class="card-header-toggle-icon">
            <span *ngIf="isCollapseOpened">
                <i class="fas fa-chevron-up"></i>
            </span>
            <span *ngIf="!isCollapseOpened">
                <i class="fas fa-chevron-down"></i>
            </span>            
        </span>
    </div>

    <div class="collapse" #collapse>
        <div class="card-body" *ngIf="isLoading">
            <p class="text-center" *ngIf="isLoading">
                <i class='fas fa-spinner fa-pulse'></i> Carregando os itens
            </p>
        </div>
    
        <div class="card-body" *ngIf="isLoaded && (!pedidos || pedidos.length === 0)">
            <p class="text-center">
                Nenhum item
            </p>    
        </div>

        <div class="table-responsive" *ngIf="isLoaded && pedidos?.length > 0">
            <table class="table table-striped table-hover table-bordered">
                <thead>
                    <tr>
                        <th class="col-numero text-right">Número</th>
                        <th class="col-data-emissao text-center">Emissão</th>
                        <th class="col-tipo text-center">Tipo</th>
                        <th class="col-quantidade text-right">Quantidade</th>
                        <th class="col-valor-total text-right">Total</th>
                        <th class="col-cliente">Cliente</th>
                        <th class="col-representante">Representante</th>
                        <th class="col-tabela-preco">Tabela de Preço</th>
                        <th class="col-condicao-pagamento">Condição de Pagamento</th>
                        <th class="col-motivo-nao-liberado">Motivo Não Liberado</th>
                        <th class="col-data-nao-liberado text-center">Data Não Liberado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let pedido of pedidos">
                        <td class="col-numero text-right" [title]="pedido.numero">
                            {{pedido.numero}}
                        </td> 
                        <td class="col-data-emissao text-center" [title]="pedido.dataEmissao | date: 'dd/MM/yyyy - HH:mm'">
                            {{pedido.dataEmissao | date: 'dd/MM/yyyy - HH:mm'}}
                        </td>
                        <td class="col-tipo text-center" [title]="pedido.tipoVenda | pedidoTipoVenda">
                            <sgt-config-pedido-tipo-venda-badge
                                [tipoVenda]="pedido.tipoVenda">
                            </sgt-config-pedido-tipo-venda-badge>
                        </td>                        
                        <td class="col-quantidade text-right" [title]="pedido.quantidadeTotal | decimalFormat: 1:0:0">
                            {{pedido.quantidadeTotal | decimalFormat: 1:0:0}}
                        </td>
                        <td class="col-valor-total text-right" [title]="pedido.valorTotal | currencyFormat: 1:2:2">
                            {{pedido.valorTotal | currencyFormat: 1:2:2}}
                        </td> 
                        <td class="col-cliente" [title]="pedido.nomePessoa | clienteNome: pedido.nomeFantasiaPessoa:pedido.codigoIntegracaoErpPessoa">
                            {{pedido.nomePessoa | clienteNome: pedido.nomeFantasiaPessoa:pedido.codigoIntegracaoErpPessoa}}
                        </td> 
                        <td class="col-representante" [title]="pedido.nomeRepresentante | representanteNome: pedido.nomeFantasiaRepresentante">
                            {{pedido.nomeRepresentante | representanteNome: pedido.nomeFantasiaRepresentante}}
                        </td> 
                        <td class="col-tabela-preco" [title]="pedido.nomeTabelaPreco">
                            <span *ngIf="pedido.codigoIntegracaoErpTabelaPreco">{{pedido.codigoIntegracaoErpTabelaPreco}} - </span> {{pedido.nomeTabelaPreco}}
                        </td>
                        <td class="col-condicao-pagamento" [title]="pedido.nomeCondicaoPagamento">
                            {{pedido.nomeCondicaoPagamento}}
                        </td>
                        <td class="col-motivo-nao-liberado" [title]="pedido.motivoNaoLiberado | pedidoMotivoNaoLiberadoAbreviacao">
                            {{pedido.motivoNaoLiberado | pedidoMotivoNaoLiberadoAbreviacao}}
                        </td>
                        <td class="col-data-nao-liberado text-center" [title]="pedido.dataNaoLiberado | date: 'dd/MM/yyyy - HH:mm'">
                            {{pedido.dataNaoLiberado | date: 'dd/MM/yyyy - HH:mm'}}
                        </td>
                    </tr>
                </tbody>              
            </table>
        </div>
    </div>
</div>